<template>
  <div>
    <div v-if="$auth.isAdmin() || $auth.isDev()">
      <v-btn color="success" small outline :href="overweight.evidence_file_url" target="_blank" v-if="overweight.evidence_file_url">
        {{ $t('download') }}
      </v-btn>

      <v-btn color="primary" small @click="deductOverweight(overweight)" v-if="overweight.status == 'unpaid'" :disabled="loading">
        {{ $t('apply') }}
      </v-btn>

      <v-btn color="primary" small outline @click="refund(overweight)" v-if="overweight.status === 'paid'" :disabled="loading">
        {{ $t('refund') }}
      </v-btn>

      <v-btn color="primary" small outline @click="refund(overweight)" v-if="overweight.status === 'rebated'" :disabled="loading">
        {{ $t('acceptRebateRequest') }}
      </v-btn>

      <v-btn color="primary" small @click="cancelRebate(overweight)" v-if="overweight.status === 'rebated'" :disabled="loading">
        {{ $t('cancelRebateRequest') }}
      </v-btn>
    </div>

    <div v-if="$auth.isCust() && canRebate">
      <v-btn color="primary" small @click="rebate(overweight)" v-if="overweight.status == 'paid'" :disabled="loading">
        {{ $t('requestRebate') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "OverweightRowButtonsComp",

  data () {
    return {
      loading: false
    }
  },

  props: {
    overweight: {
      type: Object,
      required: true
    },

    canRebate: {
      type: Boolean,
      default: false
    },
  },

  components: {
  },

  computed: {
  },

  methods: {
    async deductOverweight () {
      this.loading = true
      try {
        await this.overweight.apply()
        this.$emit('fetch')
        this.setNotification({
          color: 'success',
          message: this.$t('successfullySavedNotification')
        })
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    },

    async rebate () {
      this.loading = true
      try {
        await this.overweight.rebate()
        this.$emit('fetch')
        this.setNotification({
          color: 'success',
          message: this.$t('successfullySavedNotification')
        })
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    },

    async refund () {
      this.loading = true
      try {
        await this.overweight.refund()
        this.$emit('fetch')
        this.setNotification({
          color: 'success',
          message: this.$t('successfullySavedNotification')
        })
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    },

    async cancelRebate () {
      this.loading = true
      try {
        await this.overweight.cancelRebate()
        this.$emit('fetch')
        this.setNotification({
          color: 'success',
          message: this.$t('successfullySavedNotification')
        })
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    },
  },

  watch: {
  },

  mounted () {
  }
}
</script>
